module.exports = __webpack_public_path__ + "assets/img/male-avatar.png?705ce8e584cf83cf7758c102ac9709db";